<app-notification-layout
  [desktopImageSrc]="'/img/sim-activated.png'"
  [mobileImageSrc]="'/img/sim-activated.png'"
  [title]="'Tu sim ya se encuentra activa'"
>
  <div class="notif">
    <p class="notif__text">Sigue disfrutando de todos nuestros servicios.</p>

    <div class="notif__actions">
      <button routerLink="/activate-form" class="btn">FINALIZAR</button>
    </div>
  </div>
</app-notification-layout>
